<h1 mat-dialog-title>
  {{data.title}}
</h1>

<div mat-dialog-content>
  <p>{{data.message}}</p>
  <p *ngIf="data.warning" class="dialog-warning">
    <mat-icon inline>warning</mat-icon>
    {{data.warning}}
  </p>
</div>

<div mat-dialog-actions>
  <button mat-button (click)="onCancel()" color="{{data.cancelColor}}">{{data.cancelText}}</button>
  <button mat-raised-button (click)="onConfirm()" color="{{data.confirmColor}}">{{data.confirmText}}</button>
</div>
